import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Phone, ArrowRight } from "lucide-react";

const PHONE_LINK = "tel:+33549057490";

export const PanneHero = ({ panne, Icon }) => (
  <section className="relative py-16 md:py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-red-900 text-white overflow-hidden">
    <div className="absolute inset-0 opacity-10">
      <div className="absolute top-10 right-10 w-72 h-72 bg-red-500 rounded-full blur-3xl"></div>
    </div>

    <div className="container-custom relative">
      <Badge className="bg-white/10 text-white border border-white/20 px-4 py-2 mb-6 hover:bg-white/10">
        <Icon className="w-4 h-4 mr-2" />
        {panne.category} • Niort 79000
      </Badge>

      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
        {panne.titleH1}
      </h1>

      <p className="text-lg md:text-xl text-slate-200 max-w-3xl mb-8 leading-relaxed">
        Diagnostic <strong className="text-white">gratuit</strong>, intervention en
        <strong className="text-red-400"> {panne.durationLabel}</strong>, garantie
        <strong className="text-white"> 6 mois pièces + main-d&apos;œuvre</strong>. Mediastore
        Niort, spécialiste Apple certifié, intervient sur tous les modèles à partir de
        <strong className="text-red-400"> {panne.priceFrom} €</strong>.
      </p>

      <div className="flex flex-col sm:flex-row gap-4">
        <a href={PHONE_LINK}>
          <Button size="lg" className="w-full sm:w-auto bg-red-600 hover:bg-red-700 h-14 px-8 gap-2 text-lg font-semibold shadow-xl" data-testid="panne-call-btn">
            <Phone className="h-5 w-5" />
            05 49 05 74 90
          </Button>
        </a>
        <Link to="/rendez-vous">
          <Button size="lg" variant="outline" className="w-full sm:w-auto h-14 px-8 gap-2 border-2 border-white/30 text-white hover:bg-white/10" data-testid="panne-rdv-btn">
            Prendre rendez-vous
            <ArrowRight className="h-5 w-5" />
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-3 gap-4 mt-8 max-w-md">
        <div className="text-center">
          <p className="text-3xl font-bold text-red-400">4.6★</p>
          <p className="text-xs text-slate-300">212+ avis Google</p>
        </div>
        <div className="text-center border-x border-white/20">
          <p className="text-3xl font-bold text-red-400">{panne.priceFrom}€</p>
          <p className="text-xs text-slate-300">dès</p>
        </div>
        <div className="text-center">
          <p className="text-3xl font-bold text-red-400">6 mois</p>
          <p className="text-xs text-slate-300">garantie incluse</p>
        </div>
      </div>
    </div>
  </section>
);
